//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { uploadEnrollPhoto } from '@/https/prepareEnroll'
import uploadImg from '@/assets/img/upload.png'
import { success } from '@/utils/notify.js'

export default {

  props: {
    options: {
      type: Object,
      default: () => ({}),
    },
  },

  data () {
    return {
      uploadImg,
      uploadParams: {},
      uploadList: [],
    }
  },

  computed: {
    description () {
      return this.options?.bmbMbDetailItem?.zpggsm || ''
    },
  },

  watch: {
    'options.ksxxItem': {
      handler (val) {
        const url = this.options?.ksxxItem?.zpdz
        this.uploadList = url ? [{ url }] : []

        if (val.wid) {
          this.uploadParams = { ksWid: val.wid }
        }
      },
      immediate: true,
      deep: true,
    },
  },

  methods: {
    uploadEnrollPhoto,

    _validate () {
      this.errorMsg = '请上传个人照片'

      return !!this.uploadList[0].url
    },

    async uploadSuccess (val) {
      success('保存成功')
      setTimeout(async (e) => {
        this.$emit('on-back')
      }, 500)
    },
  },
}
